// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
// @ts-ignore -- Unused import
import { jsonLightReadStringPropertyValue } from '@msdyn365-commerce/retail-proxy/dist/externals';

/**
 * ProfileModel entity interface.
 */
export interface IProfileModel {
    LiquorSmsOptIn: boolean;
    LiquorEmailOptIn: boolean;
    CannabisSmsOptIn: boolean;
    CannabisEmailOptIn: boolean;
    Id?: string;
    Email?: string;
    Phone?: string;
    ExternalId?: string;
    FirstName?: string;
    LastName?: string;
    Gender?: string;
    DateOfBirth?: string;
    Address?: IAddress;
    Subscriptions?: ISubscriptions;
    E4LoyaltyMarketingChangesInProcess?: boolean;
}

/**
 * Address entity interface.
 */
export interface IAddress {
    Address1?: string;
    Address2?: string;
    City?: string;
    Country?: string;
    Region?: string;
    Zip?: string;
}

/**
 * Subscriptions entity interface.
 */
export interface ISubscriptions {
    EmailSubscription?: IEmailSubscription;
    SmsSubscription?: ISmsSubscription;
}

/**
 * EmailSubscription entity interface.
 */
export interface IEmailSubscription {
    MarketingSubscription?: ISubscription;
}

/**
 * Subscription entity interface.
 */
export interface ISubscription {
    Consent?: string;
    ConsentedAt?: string;
}

/**
 * SmsSubscription entity interface.
 */
export interface ISmsSubscription {
    MarketingSubscription?: ISubscription;
    TransactionalSubscription?: ISubscription;
}

/**
 * ProfileModel entity class.
 */
export class ProfileModelExtensionClass implements IProfileModel {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Id: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Email: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Phone: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ExternalId: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public FirstName: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public LastName: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Gender: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public DateOfBirth: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Address: IAddress;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public CannabisEmailOptIn: boolean;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public CannabisSmsOptIn: boolean;

    public LiquorEmailOptIn!: boolean;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public LiquorSmsOptIn: boolean;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Subscriptions: ISubscriptions;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public E4LoyaltyMarketingChangesInProcess: boolean;

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Id = odataObject.Id;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Email = odataObject.Email;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Phone = odataObject.Phone;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ExternalId = odataObject.ExternalId;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.FirstName = odataObject.FirstName;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.LastName = odataObject.LastName;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Gender = odataObject.Gender;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.DateOfBirth = odataObject.DateOfBirth;

        if (odataObject.Address === null || odataObject.Address === undefined) {
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.Address = undefined;
        } else if (odataObject?.Address['@odata.type'] === null || odataObject?.Address['@odata.type'] === undefined) {
            this.Address = new AddressExtensionClass(odataObject.Address);
        } else {
            var className: string = odataObject.Address['@odata.type'];
            className = className.substr(className.lastIndexOf('.') + 1).concat('Class');
            // @ts-ignore
            // eslint-disable-next-line security/detect-object-injection
            if (EntityClasses[className]) {
                // @ts-ignore
                // eslint-disable-next-line security/detect-object-injection
                this.Address = new EntityClasses[className](odataObject.Address);
            }
        }

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.CannabisEmailOptIn = odataObject.CannabisEmailOptIn;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.CannabisSmsOptIn = odataObject.CannabisSmsOptIn;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.LiquorEmailOptIn = odataObject.LiquorEmailOptIn;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.LiquorSmsOptIn = odataObject.LiquorSmsOptIn;

        if (odataObject?.Subscriptions === null || odataObject?.Subscriptions === undefined) {
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.Subscriptions = undefined;
        } else if (odataObject.Subscriptions['@odata.type'] === null || odataObject.Subscriptions['@odata.type'] === undefined) {
            this.Subscriptions = new SubscriptionsExtensionClass(odataObject.Subscriptions);
        } else {
            className = odataObject.Subscriptions['@odata.type'];
            className = className.substr(className.lastIndexOf('.') + 1).concat('Class');
            // @ts-ignore
            // eslint-disable-next-line security/detect-object-injection
            if (EntityClasses[className]) {
                // @ts-ignore
                // eslint-disable-next-line security/detect-object-injection
                this.Subscriptions = new EntityClasses[className](odataObject.Subscriptions);
            }
        }

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.E4LoyaltyMarketingChangesInProcess = odataObject.E4LoyaltyMarketingChangesInProcess;
    }
}

/**
 * Address entity class.
 */
export class AddressExtensionClass implements IAddress {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Address1: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Address2: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public City: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Country: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Region: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Zip: string;

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Address1 = odataObject.Address1;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Address2 = odataObject.Address2;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.City = odataObject.City;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Country = odataObject.Country;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Region = odataObject.Region;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Zip = odataObject.Zip;
    }
}

/**
 * Subscriptions entity class.
 */
export class SubscriptionsExtensionClass implements ISubscriptions {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public EmailSubscription: IEmailSubscription;
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public SmsSubscription: ISmsSubscription;
    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        if (odataObject?.EmailSubscription === null || odataObject?.EmailSubscription === undefined) {
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.EmailSubscription = undefined;
        } else if (odataObject.EmailSubscription['@odata.type'] === null || odataObject.EmailSubscription['@odata.type'] === undefined) {
            this.EmailSubscription = new EmailSubscriptionExtensionClass(odataObject.EmailSubscription);
        } else {
            var className: string = odataObject.EmailSubscription['@odata.type'];
            className = className.substr(className.lastIndexOf('.') + 1).concat('Class');
            // @ts-ignore
            // eslint-disable-next-line security/detect-object-injection
            if (EntityClasses[className]) {
                // @ts-ignore
                // eslint-disable-next-line security/detect-object-injection
                this.EmailSubscription = new EntityClasses[className](odataObject.EmailSubscription);
            }
        }

        if (odataObject.SmsSubscription === null || odataObject.SmsSubscription === undefined) {
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.SmsSubscription = undefined;
        } else if (odataObject?.SmsSubscription['@odata.type'] === null || odataObject?.SmsSubscription['@odata.type'] === undefined) {
            this.SmsSubscription = new SmsSubscriptionExtensionClass(odataObject.SmsSubscription);
        } else {
            className = odataObject.SmsSubscription['@odata.type'];
            className = className.substr(className.lastIndexOf('.') + 1).concat('Class');
            // @ts-ignore
            // eslint-disable-next-line security/detect-object-injection
            if (EntityClasses[className]) {
                // @ts-ignore
                // eslint-disable-next-line security/detect-object-injection
                this.SmsSubscription = new EntityClasses[className](odataObject.SmsSubscription);
            }
        }
    }
}

/**
 * EmailSubscription entity class.
 */
export class EmailSubscriptionExtensionClass implements IEmailSubscription {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public MarketingSubscription: ISubscription;

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        if (odataObject?.MarketingSubscription === null || odataObject?.MarketingSubscription === undefined) {
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.MarketingSubscription = undefined;
        } else if (
            odataObject.MarketingSubscription['@odata.type'] === null ||
            odataObject.MarketingSubscription['@odata.type'] === undefined
        ) {
            this.MarketingSubscription = new SubscriptionExtensionClass(odataObject.MarketingSubscription);
        } else {
            var className: string = odataObject.MarketingSubscription['@odata.type'];
            className = className.substr(className.lastIndexOf('.') + 1).concat('Class');
            // @ts-ignore
            // eslint-disable-next-line security/detect-object-injection
            if (EntityClasses[className]) {
                // @ts-ignore
                // eslint-disable-next-line security/detect-object-injection
                this.MarketingSubscription = new EntityClasses[className](odataObject.MarketingSubscription);
            }
        }
    }
}

/**
 * Subscription entity class.
 */
export class SubscriptionExtensionClass implements ISubscription {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Consent: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ConsentedAt: string;

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Consent = odataObject.Consent;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ConsentedAt = odataObject.ConsentedAt;
    }
}

/**
 * SmsSubscription entity class.
 */
export class SmsSubscriptionExtensionClass implements ISmsSubscription {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public MarketingSubscription: ISubscription;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public TransactionalSubscription: ISubscription;

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        if (odataObject?.MarketingSubscription === null || odataObject?.MarketingSubscription === undefined) {
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.MarketingSubscription = undefined;
        } else if (
            odataObject.MarketingSubscription['@odata.type'] === null ||
            odataObject.MarketingSubscription['@odata.type'] === undefined
        ) {
            this.MarketingSubscription = new SubscriptionExtensionClass(odataObject.MarketingSubscription);
        } else {
            var className: string = odataObject.MarketingSubscription['@odata.type'];
            className = className.substr(className.lastIndexOf('.') + 1).concat('Class');
            // @ts-ignore
            // eslint-disable-next-line security/detect-object-injection
            if (EntityClasses[className]) {
                // @ts-ignore
                // eslint-disable-next-line security/detect-object-injection
                this.MarketingSubscription = new EntityClasses[className](odataObject.MarketingSubscription);
            }
        }

        if (odataObject?.TransactionalSubscription === null || odataObject?.TransactionalSubscription === undefined) {
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.TransactionalSubscription = undefined;
        } else if (
            odataObject.TransactionalSubscription['@odata.type'] === null ||
            odataObject.TransactionalSubscription['@odata.type'] === undefined
        ) {
            this.TransactionalSubscription = new SubscriptionExtensionClass(odataObject.TransactionalSubscription);
        } else {
            className = odataObject.TransactionalSubscription['@odata.type'];
            className = className.substr(className.lastIndexOf('.') + 1).concat('Class');
            // @ts-ignore
            // eslint-disable-next-line security/detect-object-injection
            if (EntityClasses[className]) {
                // @ts-ignore
                // eslint-disable-next-line security/detect-object-injection
                this.TransactionalSubscription = new EntityClasses[className](odataObject.TransactionalSubscription);
            }
        }
    }
}
